import React from 'react';
import ViewHeader from './header/ViewHeader';
import ViewTop from './container/ViewTop';
import ViewContent from './container/ViewContent';
import ViewFooter from './footer/ViewFooter';
import './view.css';
import {Breadcrumb, Button, Card, Col, Divider, Image, Input, Layout, Pagination, Row, Space, Spin} from "antd";
import { Link , Redirect } from "react-router-dom";
import {Helmet} from "react-helmet";

import {
    AppstoreOutlined,
    SearchOutlined,
    LoginOutlined,
    PieChartOutlined,
    DesktopOutlined,
    MailOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined,
    HomeOutlined,
    ContainerOutlined,
    LoadingOutlined
} from '@ant-design/icons';

const { Meta } = Card;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const  {Content, Footer} = Layout;


class View extends React.Component {

    constructor(props){
        super(props)

        this.state ={
            systemConfig: {},
            viewPlate: {},
            items: {}
        }
    }

    loadView(viewId, pageNo) {

        this.setState({
            loading: true
        })

        let formData = new FormData()
        formData.append('id', viewId)

        let host = process.env.REACT_APP_HOST

        fetch(host + "/site/view/detailView", {method: 'POST', body: formData})
            .then(response => response.json())
            .then(data => {

                this.setState({
                    viewPlate: data.data.map.viewPlate,
                    systemConfig: data.data.map.systemConfig
                })

                var html = {__html:this.state.viewPlate.content};
                var content = <div dangerouslySetInnerHTML={html}></div>;
                var attachment = <></>
                if(this.state.viewPlate.attachment) {
                    attachment = <Image src={this.state.viewPlate.attachment} />
                }

                var video = <></>
                if((this.state.viewPlate.iframe != "") && (this.state.viewPlate.hasVideo === 'Y')) {
                    video = <iframe src={this.state.viewPlate.iframe} style={{width: 400, height: 300}}/>
                }

                var parent = <></>

                if(this.state.viewPlate.parent) {
                    var parentLink = "/site/view/" + this.state.viewPlate.parent.id
                    parent = <Breadcrumb.Item><a href={parentLink}>{this.state.viewPlate.parent.title}</a></Breadcrumb.Item>
                }

                var title=this.state.viewPlate.title

                this.setState({
                    title: title,
                    video: video,
                    parent: parent,
                    content: content,
                    attachment: attachment
                })

                if(this.state.viewPlate.isParent != 'Y') {
                    this.setState({
                        items: [],
                        loading: false
                    })
                } else {
                    this.loadSubView(viewId, pageNo)
                }

            })

    }

    loadSubView(viewId, pageNo) {
        if(!pageNo) pageNo = 1
        let formData = new FormData()
        formData.append('id', viewId)
        formData.append('pageNo', pageNo)

        let host = process.env.REACT_APP_HOST

        fetch(host + "/site/view/subPage", {method: 'POST', body: formData})
            .then(response => response.json())
            .then(data => {
                this.setState({
                    subView: data.data.map.pageModel.recordList,
                    page: data.data.map.pageModel,
                })

                let items = this.extracted();

                this.setState({
                    items: items,
                    loading: false
                })
            })

    }

    extracted() {
        let items = []

        for (var subView in this.state.subView) {
            var link = "/site/view/" + this.state.subView[subView].id
            var item = (
                <a href={link}>
                    <Card
                        hoverable
                        style={{width: 230}}
                        cover={<img height="300" alt={this.state.subView[subView].title}
                                    src={this.state.subView[subView].attachment}/>}
                    >
                        <Meta style={{height: 40}} title={this.state.subView[subView].title}
                              description={this.state.subView[subView].description}/>
                    </Card>
                </a>
            );
            items.push(item)
        }
        return items;
    }

    onChange = (page) => {
        console.log(page);
        this.setState({
            current: page,
            loading: true,
        });

        var viewId = this.state.viewPlate.id

        this.loadView(viewId, page)
    };


    componentDidMount() {
        console.log("mount")
        var viewId = this.props.match.params.id

        this.loadView(viewId, 1)

    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log("receive props")
        console.log(this.props.match.params.id);
        var viewId = this.props.match.params.id
        if(viewId != this.state.viewPlate.id){
            this.loadView(viewId)
        }

    }

    render() {
        if(this.state.viewPlate.useUrl === 'Y') {
            window.location.href=this.state.viewPlate.iframe
        }

        return (
            <>
                <ViewHeader viewPlate={this.state.viewPlate} systemConfig={this.state.systemConfig}></ViewHeader>
                <Layout>
                    <ViewTop viewPlate={this.state.viewPlate} systemConfig={this.state.systemConfig}></ViewTop>
                    <div style={{backgroundColor:'#ffffff', padding: 10, margin: 0}}>
                        <ViewContent systemConfig={this.state.systemConfig} title={this.state.title} video={this.state.video} attachment={this.state.attachment}></ViewContent>
                        <Spin indicator={antIcon} spinning={this.state.loading}>
                            <Row>
                                <Col span={24}>
                                    {this.state.items.length>0?<Pagination showSizeChanger={false} onChange={this.onChange} defaultCurrent={this.state.page.pageNo} pageSize={this.state.page.pageSize} total={this.state.page.totalRecord} />:<p></p>}
                                </Col>
                            </Row>
                            <Space  align='start' wrap>
                                {this.state.items.length>0?this.state.items:this.state.content}
                            </Space>
                        </Spin>
                    </div>
                    <ViewFooter systemConfig={this.state.systemConfig}></ViewFooter>
                </Layout>

            </>
        )
    }

}

export default View;
